import { z } from 'zod';
import { localeSchema } from './content.js';
/**
 * The contact form on /kontakt. Everything lands in Diana's panel — no
 * Google Forms, no third party holding her leads.
 */
export const leadInputSchema = z.object({
    name: z.string().min(1, 'Podaj imię').max(120),
    email: z.string().email('Nieprawidłowy adres e-mail').max(200),
    message: z.string().min(1, 'Napisz wiadomość').max(4000),
    locale: localeSchema.default('pl'),
    source: z.string().max(80).default('contact-form'),
    /**
     * Honeypot. Real people leave it empty; most bots fill every field they
     * find. Cheaper and less annoying than a captcha.
     *
     * Deliberately permissive: the schema must ACCEPT a filled value so the
     * route can decide what to do. Rejecting it here would return a 400 that
     * tells the bot precisely which field is the trap — and would make it
     * retry without filling it. The route returns a silent 200 instead.
     */
    website: z.string().max(200).optional(),
});
export const leadSchema = leadInputSchema.omit({ website: true }).extend({
    id: z.string().uuid(),
    handled: z.boolean(),
    createdAt: z.coerce.date(),
});
/**
 * Newsletter signup. The email list is the only audience Diana truly owns —
 * Instagram can change its algorithm overnight, a mailing list can't.
 */
export const subscriberInputSchema = z.object({
    email: z.string().email('Nieprawidłowy adres e-mail').max(200),
    locale: localeSchema.default('pl'),
    source: z.string().max(80).default('site'),
    /** Honeypot — see leadInputSchema above. */
    website: z.string().max(200).optional(),
});
export const subscriberSchema = subscriberInputSchema.omit({ website: true }).extend({
    id: z.string().uuid(),
    confirmedAt: z.coerce.date().nullable(),
    unsubscribedAt: z.coerce.date().nullable(),
    createdAt: z.coerce.date(),
});
